import React from 'react';
import { withGoogleMap, GoogleMap, OverlayView } from 'react-google-maps';
import { Trans } from 'react-i18next';
import history from '../../history';
import ReactModal from 'react-modal';

const getPixelPositionOffset = (width, height) => ({
  x: -(width / 2),
  y: -(height / 2),
});

class MapDialog extends React.Component {
  constructor() {
    super();
    this.state = {
      showModal: false,
    };

    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleOpenModal() {
    this.setState({ showModal: true });
  }

  handleCloseModal() {
    this.setState({ showModal: false });
  }

  goMaison = () => {
    this.setState({ showModal: false });
    history.push('/Maison');
  };
  goentre = () => {
    this.setState({ showModal: false });
    history.push('/entre');
  };
  goMaisonsHote = () => {
    this.setState({ showModal: false });
    history.push('/MaisonsHote');
  };
  goMosquee = () => {
    this.setState({ showModal: false });
    history.push('/Mosquee');
  };
  goDaraelfeija = () => {
    this.setState({ showModal: false });
    history.push('/Daraelfeija');
  };
  goZaouia = () => {
    this.setState({ showModal: false });
    history.push('/Zaouia');
  };
  goPaysage = () => {
    this.setState({ showModal: false });
    history.push('/Paysage');
  };

  render() {
    const MapWithAMarker = withGoogleMap(props => (
      <GoogleMap
        defaultZoom={18}
        defaultCenter={{ lat: 36.31417, lng: 10.21069 }}
        mapTypeId={'satellite'}
      >
        <OverlayView
          position={{ lat: 36.314114, lng: 10.21 }}
          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          getPixelPositionOffset={getPixelPositionOffset}
        >
          <div>
            <img
              style={{ width: `30px`, height: '30px' }}
              src="../assets/images/1_off.png"
              alt=""
              onClick={this.goentre}
            />
          </div>
        </OverlayView>

        <OverlayView
          position={{ lat: 36.313972, lng: 10.210471 }}
          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          getPixelPositionOffset={getPixelPositionOffset}
        >
          <img
            style={{ width: `30px` }}
            src="../assets/images/2_off.png"
            alt=""
            onClick={this.goMaisonsHote}
          />
        </OverlayView>

        <OverlayView
          position={{ lat: 36.314395, lng: 10.210727 }}
          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          getPixelPositionOffset={getPixelPositionOffset}
        >
          <img
            style={{ width: `30px` }}
            src="../assets/images/3_off.png"
            alt=""
            onClick={this.goMaison}
          />
        </OverlayView>

        <OverlayView
          position={{ lat: 36.314222, lng: 10.211074 }}
          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          getPixelPositionOffset={getPixelPositionOffset}
        >
          <img
            style={{ width: `30px` }}
            src="../assets/images/4_on.png"
            alt=""
            onClick={this.goMosquee}
          />
        </OverlayView>

        <OverlayView
          position={{ lat: 36.314289, lng: 10.210869 }}
          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          getPixelPositionOffset={getPixelPositionOffset}
        >
          <img
            style={{ width: `30px` }}
            src="../assets/images/5_off.png"
            alt=""
            onClick={this.goZaouia}
          />
        </OverlayView>

        <OverlayView
          position={{ lat: 36.31407, lng: 10.210918 }}
          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          getPixelPositionOffset={getPixelPositionOffset}
        >
          <img
            style={{ width: `30px` }}
            src="../assets/images/6_off.png"
            alt=""
            onClick={this.goPaysage}
          />
        </OverlayView>

        <OverlayView
          position={{ lat: 36.314127, lng: 10.210672 }}
          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          getPixelPositionOffset={getPixelPositionOffset}
        >
          <img
            style={{ width: `30px` }}
            src="../assets/images/8_off.png"
            alt=""
            onClick={this.goDaraelfeija}
          />
        </OverlayView>
      </GoogleMap>
    ));
    return (
      <div>
        <li
          style={{ cursor: `pointer` }}
          onClick={this.handleOpenModal}
          className="mapbtn"
        >
          <a>
            <Trans i18nKey="menu.carte">Carte</Trans>
          </a>
        </li>
        <div>
          <ReactModal
            isOpen={this.state.showModal}
            contentLabel="Minimal Modal Example"
            className="reaactmodal"
            onClick={this.handleCloseModal}
            style={{
              overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                zIndex: `99`,
                marginTop: `-45px`,
              },
              content: {
                color: '#000',
              },
            }}
          >
            <p className="infotext" style={{ top: `40px` }}>
              <Trans i18nKey="menu.carte">Carte</Trans>
            </p>
            <p className="contentmodal">
              <MapWithAMarker
                containerElement={
                  <div style={{ height: `350px`, width: 350 }} />
                }
                mapElement={<div style={{ height: `100%` }} />}
              />
            </p>
            <span onClick={this.handleCloseModal} className="clsiconpo">
              <p className="clspopup">
                <Trans i18nKey="modal.fermer">Fermer</Trans>
              </p>
            </span>
          </ReactModal>
        </div>
      </div>
    );
  }
}

export default MapDialog;



// WEBPACK FOOTER //
// ./src/components/App/MapDialog.js